import Phaser from 'phaser'
import { SCALE, TILES_BY_SCREEN, TILE_SIZE } from '../utils/constants'
import CRTFilter from '../utils/CRTShaderFX'
import UI from '../components/UI'

export default class IntroScene extends Phaser.Scene {
  constructor () {
    super('CreditsScene');
  }

  create() {
    this.normalDayMusic = this.sound.add('opening_peace', { loop: true })
    this.normalDayMusic.play();

    this.cameras.main.setPostPipeline(CRTFilter);
    let image = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'theworld')
    let scaleX = this.cameras.main.width / image.width
    let scaleY = this.cameras.main.height / image.height
    let scale = Math.max(scaleX, scaleY)
    image.setScale(scale).setScrollFactor(0)
    image.name = 'background_art'
    image.alpha = 0
    this.tweens.add({
      targets: image,
      alpha: 1,
      duration: 5000,
    })
    const line1 = this.add.text(80, 10, "THE END",
      {
        fontFamily: 'GameGirl',
        fontSize: "10px",
        fill: "#ffffff",
      }
    ).setScale(scaleX * 2).setPosition(2 * scaleX, this.cameras.main.height - 20 * 4 * scaleY).setShadow(-1,1)
    line1.displayHeight = 10 * scaleY
    const line2 = this.add.text(80, 10, "Thanks for playing",
      {
        fontFamily: 'GameGirl',
        fontSize: "10px",
        fill: "#ffffff",
      }
    ).setScale(scaleX * 0.9).setPosition(2 * scaleX, this.cameras.main.height - 10 * 3 * scaleY).setShadow(-1,1)
    line2.displayHeight = 10 * scaleY
  }
}